export default function Button(props) {
  const {type, onClick, className} = props;

  return(
    <button className={className} type={type} onClick={onClick}>
      {props.children}
    </button>
  );
};
